<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <div class="row">
        <div class="col-12 text-right" v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')">
          <button
            class="btn btn-info"
            @click="initUserGroup"
            v-b-modal.modal-userGroup
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </div>
      </div>
      <div class="row h-100">
        <div class="col-sm-12 h-100 pb-5">
          <div class="tab-content  bg-white h-100">
            <div class="tab-pane active table-responsive color-table">
              <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
              >
                <template slot="Action" slot-scope="props">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-if="hasRight(Settings.Permission.Change)"
                      v-b-modal.modal-userGroup
                      @click="onEditUserGroup(props.row)"
                    />

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      v-if="hasRight('AlwDel')"
                      @click="deleteUserGroup(props.row)"
                    />
                  </div>
                </template>
              </v-client-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-userGroup"
      :title="t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddUserGroup"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.MENU_UserGrp) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                maxlength="10"
                :readonly="mode === 'new' ? false : true"
                v-model="userGroup.UserGrp"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_EngDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="userGroup.GrpDesc"
                maxlength="40"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_ChiDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="userGroup.ChiDesc"
                maxlength="40"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import UserGroupService from "@/service/UserGroupService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import { AnnualLeaveKey, CompensationKey } from "@/constants/globalConstants";
import StoreGetter from "@/constants/StoreGetter";
import { UserGroup } from "@/model/UserGroup";
import Settings from '../../constants/Settings';
export default {
  components: {},
  computed: {
    t() {
      return t;
    },
  },
  data() {
    return {
      annualLeaveKey: AnnualLeaveKey,
      compensationKey: CompensationKey,
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.UserGroups,
      Settings: Settings,
      columns: ["UserGrp", "GrpDesc", "ChiDesc", "Action"],
      tableData: [],
      dictEnum: dictEnum,
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          UserGrp: "User Group ID",
          GrpDesc: "Eng Description",
          ChiDesc: "Chi Description",
          Action: "Action"
        },
        columnsClasses: {}
      },
      userGroup: new UserGroup(),
      mode: "new"
    };
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initUserGroup() {
      this.mode = "new";
      this.userGroup = new UserGroup();
    },
    onEditUserGroup(selected) {
      this.mode = "edit";
      this.userGroup = selected;
    },
    async deleteUserGroup(selected) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          modelList: [
            {
              UserGrp: selected.UserGrp
            }
          ],
          //  UserGrp: this.delete_type,
          UserId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await UserGroupService.deleteUserGroup(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },
    async editOrAddUserGroup() {
      if (!this.userGroup.UserGrp) {
        SweetAlertService.warning("Warn", 
          t.t(dictEnum.MENU_UserGroup) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.userGroup.GrpDesc) {
        SweetAlertService.warning("Warn", 
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.userGroup.ChiDesc) {
        SweetAlertService.warning("Warn", 
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const obj = {
        model: {
          UserGrp: this.userGroup.UserGrp,
          GrpDesc: this.userGroup.GrpDesc,
          ChiDesc: this.userGroup.ChiDesc,
          AddBy: this.$store.getters[StoreGetter.user].UserID
        }
      };

      const response =
        this.mode === "new"
          ? await UserGroupService.addUserGroup(obj)
          : await UserGroupService.updateUserGroup(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDataTable() {
      const obj = {};
      const response = await UserGroupService.getUserGroups(obj);
      if (!response.data.IsSuccess) {
        SweetAlertService.warning("Warn", response.data.Message);
      } else {
        this.tableData = response.data.Data;
      }
    }
  },

  mounted() {
    this.assignRights();
    this.getDataTable();

    this.options = {
      filterable: false,
      perPageValues: [],
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        UserGrp: t.t(dictEnum.LBL_UserGrp),
        GrpDesc: t.t(dictEnum.LBL_EngDesc),
        ChiDesc: t.t(dictEnum.LBL_ChiDesc),
        //DaysAdv: t.t(dictEnum.LBL_AdvanceApplyDay),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S060000-Admin/S060200-UserGroup.vue